<template>
  <div>
    <el-upload
      v-if="sourceType == 0"
      :id="componentId || 'superupload'"
      ref="ziji"
      :class="['avatar-uploader', fileList.length >= option.limit ? 'disUoloadSty' : '']"
      name="file"
      :on-remove="handleRemove"
      :on-error="upError"
      :action="baseUrl"
      list-type="picture-card"
      :headers="headers"
      :file-list="fileList"
      :on-change="handleChange"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      accept="image/*"
      :limit="option.limit"
    >
      <div>
        <i class="el-icon-plus avatar-uploader-icon">上传图片</i>
      </div>
    </el-upload>
    <el-upload
      v-if="sourceType == 1"
      :id="componentId || 'superVideoupload'"
      class="avatar-uploader"
      name="file"
      :action="baseUrl"
      :on-error="upError"
      :headers="headers"
      :show-file-list="false"
      :on-success="handleVideoSuccess"
      :before-upload="beforeVideoUpload"
      accept="video/*"
    >
      <div>
        <video v-if="value[0]" :src="value[0]" width="150px" height="150px" ref="video"></video>
        <i v-else class="el-icon-plus avatar-uploader-icon video-icon">上传视频</i>
      </div>
    </el-upload>
  </div>
</template>

<script>
import utils from "@/jslibs/utils";
export default {
  components: {},
  // props: ['imgLink', 'limit', 'sourceType', 'videoLink', 'audioLink', 'imgList', 'componentId', 'value'],
  props: {
    componentId: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    limit: {
      type: Number,
      default: 1,
    },
    sourceType: {
      type: [String, Number],
      default: "0",
    },
  },
  data() {
    return {
      imgList: [],
      mediaType: "0" || this.sourceType,
      fileList: [],
      option: {
        limit: this.limit || 1,
      },
      preImg: "",
      showMeta: false,
      updata: {
        source: 50,
      },
      imgBase: "https://train-service-cdn.oss-cn-shenzhen.aliyuncs.com/",
      baseUrl: process.env.VUE_APP_BASE_API + "/v1/common/UploadFile",
      headers: {
        "X-Access-Token": utils.getCookie("X-Access-Token") || "",
      },
      imageUrl: this.imgLink || "",
      videoUrl: this.videoLink || "",
      audioUrl: this.audioLink || "",
      preCover: "",
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal && oldVal.length == 0) {
        this.fileList = newVal.map((it) => {
          return {
            url: it,
          };
        });
      }
    },
    // 202111120038
    // imgList: function(newVal, oldVal) {
    //     if (newVal) {
    //    	this.fileList = newVal.map(item => { return { url: item } });
    //     }
    // },
    // videoLink: function(newVal, oldVal) {
    //     this.videoUrl = newVal;
    // },
    // fileList(val) {
    //     console.log(val)
    // }
  },
  mounted() {
    this.emitVideoDuration();
  },

  methods: {
    emitVideoDuration() {
      if (this.$refs.video && this.sourceType == 1) {
        this.$refs.video.addEventListener("canplay", () => {
          const duration = this.$refs.video.duration.toFixed(2);
          console.log("duration", duration)
          this.$emit("videoDuration", duration);
        });
      }
    },

    upError() {
      this.$message.error("上传失败");
      this.$emit("endUpload");
    },
    handleChange(file, fileList) {
      console.log(fileList);
      // this.fileList = fileList.slice(-3);
    },
    openFileSystem() {
      if (this.componentId) {
        document.querySelector("#" + this.componentId + " input").click();
      } else {
        document.querySelector("#superupload input").click();
      }
    },
    openVideoSystem() {
      if (this.componentId) {
        document.querySelector("#" + this.componentId + " input").click();
      } else {
        document.querySelector("#superVideoupload input").click();
      }
    },
    handleRemoveVideo(file, fileList) {
      // this.mediaType=1
      this.videoUrl = "";
      this.$emit("videoUrl", this.videoUrl);

      // console.log(file, fileList);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      console.log(this.fileList);
      this.fileList = fileList;
      // this.$emit('fileList', this.fileList.map(item => { return item.url }))
      this.$emit(
        "input",
        this.fileList.map((item) => {
          return item.url;
        }),
      );
    },
    getImg(url) {
      this.preImg = url;
      console.log(url);
    },
    getCover(url) {
      this.preCover = url;
      console.log(url);
    },

    beforeVideoUpload(file) {
      var fileSize = file.size / 1024 / 1024 < 10;
      if (
        ["video/mp4", "video/ogg", "video/flv", "video/avi", "video/wmv", "video/rmvb", "video/mov"].indexOf(
          file.type,
        ) == -1
      ) {
        this.$message.warning("请上传正确的视频格式");
        return false;
      }
      console.log(file, "-----");
      // if (!fileSize) {
      //     this.$message.warning("视频大小不能超过10MB");
      //     return false;
      // }
      this.$emit("startUpload");
    },
    handleVideoSuccess(res, file) {
      this.videoUrl = res.result; // 服务器返回的图片地址
      this.$emit("endUpload");

      // this.imageUrl = URL.createObjectURL(file.raw);//本地图片地址

      this.$emit("input", [this.imgBase + res.result]);
      // this.$emit('videoCover', this.videoUrl.split(',')[1])

      setTimeout(() => {
        this.emitVideoDuration();
      }, 100);
    },
    handleAvatarSuccess(res, file) {
      console.log(file);
      console.log(this.$refs.ziji);

      // console.log(this.fileList)
      this.fileList.push({
        url: this.imgBase + res.result,
        uid: file.uid,
      });
      // this.$emit('endUpload')
      this.$emit(
        "input",
        this.fileList.map((it) => {
          return it.url;
        }),
      );
      // this.$emit('fileList', this.fileList.map(item => { return item.url }))
      // this.imageUrl = res.data //服务器返回的图片地址
      // this.imageUrl = URL.createObjectURL(file.raw);//本地图片地址

      // this.$emit('fileList', this.fileList.map(item=>{return item.url}).join(','))
    },
    beforeAvatarUpload(file) {
      // file.type === 'image/gif,image/jpeg,image/jpg,image/png,image/svg';
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (["image/gif", "image/jpeg", "image/jpg", "image/png", "image/svg"].indexOf(file.type) == -1) {
        this.$message.warning("请上传正确格式的图片");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false;
      }
      this.$emit("startUpload");
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.video-box {
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eee;
  position: relative;

  video {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  .el-icon-delete {
    position: absolute;
    right: 10px;
    top: 10px;
    color: white;
    text-shadow: 0 0 10px #000;
    z-index: 1000;

    &:hover {
      color: firebrick;
    }
  }
}

.disUoloadSty /deep/ .el-upload--picture-card {
  display: none !important;
  /* 上传按钮隐藏 */
}

.select-box {
  text-align: center;
  line-height: 2;
  color: skyblue;

  & > div {
    border-bottom: 1px solid #f5f5f5;

    &:hover {
      color: royalblue;
    }

    &:last-child {
      border: none;
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 20px;
  color: #8c939d;

  text-align: center;
}

.avatar {
  width: 178px;
  /* height: 178px; */
  display: block;
}
.video-icon {
  width: 178px;
  height: 178px;
  line-height: 178px;
  background-color: #f5f5f5;
}
</style>
